import React from "react";
import PropTypes from "prop-types";
import { getStoryHeadline, getStoryLabel } from "../../../utils/story";
import { Label } from "../../../atoms/Label";
import Headline from "../../../atoms/Headline";
import SubHeadline from "../../../atoms/SubHeadline";

import "./story-card.m.css";

const CardInfo = ({ story, isHeroStory, showSubHeadline, sectionSlug }) => {
  const label = getStoryLabel(story);
  const headline = getStoryHeadline(story);
  return (
    <div styleName={`${isHeroStory ? "hero-headline-container" : "headline-container"}`}>
      {label && <Label story={story} />}

      {headline && <Headline styleName="headline" headline={headline} sectionSlug={sectionSlug} />}
      {showSubHeadline && (
        <SubHeadline styleName="sub-headline" subHeadline={story?.subheadline} sectionSlug={sectionSlug} />
      )}
    </div>
  );
};

CardInfo.propTypes = {
  story: PropTypes.shape({
    subheadline: PropTypes.string,
  }),
  showSubHeadline: PropTypes.bool,
  isHeroStory: PropTypes.bool,
  sectionSlug: PropTypes.string,
};

export default CardInfo;
